module.exports = __webpack_public_path__ + "static/media/main_bg.f70608d3.jpg";